import React, {useState} from "react";
import {GridColDef, GridValueGetterParams} from "@mui/x-data-grid";
import {Button} from "@mui/material";
import {GET_MAILS} from "../../graphql/queries/gqlGetMails";
import {GenericModal} from "../GenericModal/GenericModal";
import {MailDescription} from "../MailDescription/MailDescription";
import {MailSet} from "../../models/MailSet";
import {GraphQlDataGrid} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";

interface IMailexMailsProps {
	setId: string;
	setSet: (setId?: MailSet) => void;
}

export const MailexMails: React.FC<IMailexMailsProps> = ({ setId, setSet }) => {
	const [modalMailId, setModalMailId] = useState<string>();

	const openInformationModal = (id: string) => {
		setModalMailId(id);
	};

	const closeInformationModal = () => setModalMailId(undefined);

	const columns: GridColDef[] = [
		{
			field: "details",
			headerName: "View Details",
			width: 100,
			renderCell: (params) => {
				return (
					<Button
						onClick={() => openInformationModal(params.row.id)}
						variant="contained"
					>
						View
					</Button>
				);
			},
		},
		{ field: "id", headerName: "ID", width: 70 },
		{
			field: "status",
			headerName: "Status",
			width: 180,
		},
		{
			field: "fromMailAddress",
			headerName: "From",
			width: 200,
			valueGetter: (params: GridValueGetterParams) => {
				return params.row.fromMailAddress;
			},
		},
		{
			field: "Email",
			headerName: "Email",
			width: 200,
			valueGetter: (params: GridValueGetterParams) => {
				return params.row.metaData?.description?.relatedEmailAddress;
			},
		},
		{
			field: "RelationshipNumber",
			headerName: "Relationship Number",
			width: 200,
			valueGetter: (params: GridValueGetterParams) => {
				return params.row.metaData?.description?.relationshipNumber;
			},
		},
	];

	return (
		<div style={{ height: "100%", width: "100%" }}>
			<GraphQlDataGrid
				rows={[]}
				query={GET_MAILS}
				graphFunction={"mails"}
				client={graphQLServices.mailexClient}
				initialPageSize={10}
				rowsPerPageOptions={[10, 15, 20, 25, 50]}
				columns={columns}
				queryVariables={{ setId: setId }}
				back={() => setSet(undefined)}
			/>
			<GenericModal
				title={"Details:"}
				open={!!modalMailId}
				onClose={closeInformationModal}
			>
				{/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
				<MailDescription mailId={modalMailId!} />
			</GenericModal>
		</div>
	);
};
